import { useEffect, useState } from 'react';
import { leerEnlace, hayEnlaceEnLaUrl, EVENTO_ENLACE } from '../lib/enlace';
import { benefitsService } from '../services/benefits';

/**
 * ¿A esta persona se le ofrece el beneficio de bienvenida?
 *
 * Solo por invitación (Ricardo, 16-sep-2026): quien llega por un enlace de
 * closer o de canal que lo tenga encendido. La ruta normal enseña lo que hay y
 * vende, sin gratis.
 *
 * Dos fuentes, según haya sesión:
 *   · con sesión, manda el servidor: sabe a qué enlace quedó atribuida la cuenta
 *     y respeta a quien ya tenía cuenta antes de la regla;
 *   · sin sesión, el enlace guardado en el navegador.
 *
 * Devuelve **tres** estados: `null` mientras no se sabe. El enlace se resuelve
 * contra el servidor después de que la pantalla se monta; tratar ese hueco como
 * «no» mandaría a la ruta normal a quien sí traía invitación, y tratarlo como
 * «sí» regalaría el beneficio a quien llegó con un código inventado.
 *
 * Esto es solo presentación. La puerta real está en el servidor
 * (`User::puedeUsarBienvenida`): antes la regla vivía únicamente aquí y la home
 * con sesión la saltaba.
 *
 * @returns {boolean|null}
 */
export function useReferido() {
  const conSesion = typeof window !== 'undefined' && Boolean(localStorage.getItem('auth_token'));

  const [referido, setReferido] = useState(() => {
    if (conSesion) return null;
    const enlace = leerEnlace();
    if (enlace && !hayEnlaceEnLaUrl()) return enlace.da_beneficio;
    return hayEnlaceEnLaUrl() ? null : false;
  });

  useEffect(() => {
    if (referido !== null) return undefined;
    let vigente = true;

    if (conSesion) {
      benefitsService.getUnlockState().then((estado) => {
        if (vigente) setReferido(Boolean(estado?.puedeBienvenida && estado?.canUnlockMore));
      });
      return () => { vigente = false; };
    }

    const resolver = () => { if (vigente) setReferido(Boolean(leerEnlace()?.da_beneficio)); };
    window.addEventListener(EVENTO_ENLACE, resolver);

    /* Si el código resulta inválido el aviso no llega nunca: sin este plazo la
       pantalla esperaría para siempre algo que no va a pasar. */
    const plazo = setTimeout(resolver, 2500);

    return () => {
      vigente = false;
      window.removeEventListener(EVENTO_ENLACE, resolver);
      clearTimeout(plazo);
    };
  }, [referido, conSesion]);

  return referido;
}

export default useReferido;
